import { SliceClass } from 'interfaces';
import { NewLandingPageDocumentDataBodyAiSlice } from 'prismic';

export class AiChatSlice extends SliceClass {
  constructor(sliceData: NewLandingPageDocumentDataBodyAiSlice) {
    super(sliceData);
  }
}
